"use strict";

import $ from "jquery";
import { isParsleyForm, isValid } from "../../demi/js/scripts/parsley";

export function initInScope($scope) {
    $scope.find('.js-multiselect').each(function () {
        let $baseElement= $(this);
        let $button = $baseElement.find('.dropdown-toggle');
        let $inputs = $baseElement.find('.js-multiselect__input');
        let $hiddenInput = $baseElement.find('.js-multiselect__hidden-input');
        let $dropdown = $baseElement.find('.js-multiselect__dropdown');
        let $form = $baseElement.closest('form');

        $button.on('click touchstart', function (evt) {
            evt.preventDefault();
            evt.stopImmediatePropagation();

            $button.toggleClass('show');
            $dropdown.toggleClass('show');
            $baseElement.toggleClass('show');

            if ($baseElement.hasClass('show')) {
                $button.attr('aria-expanded', 'true');
            } else {
                $button.attr('aria-expanded', 'false');
            }
        });

        $inputs.on('click touchstart', function (evt) {
            $button.addClass('show');
            $button.attr('aria-expanded', 'true');
            $dropdown.addClass('show');
            $baseElement.addClass('show');
        });

        $inputs.on('change', function (e) {
            let oneValid = false;

            let selectedValues = '';
            let selectedLabels = '';
            $inputs.each(function () {
                if ($(this).is(':checked')) {
                    oneValid = true;
                    selectedValues += $(this).val() + ', ';
                    selectedLabels += $(this).data('label') + ', ';
                }
            });

            $hiddenInput.attr('data-values', selectedValues.substring(0, selectedValues.length - 2));
            $hiddenInput.attr('data-labels', selectedLabels.substring(0, selectedLabels.length - 2));

            if (oneValid) {
                $hiddenInput.attr('checked', 'true');
            } else {
                $hiddenInput.removeAttr('checked');
            }

            if (isParsleyForm($form)) {
                if (isValid($form)) {
                    $baseElement.addClass('is-valid');
                    $baseElement.removeClass('is-invalid');
                } else {
                    $baseElement.removeClass('is-invalid');
                    $baseElement.addClass('is-invalid');
                }
            }
        });
    });
}